import { useSelector } from "react-redux";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { AppState } from "store";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
import { useInvoiceService } from "serviceHooks";

function useReferencePersonSearch(customerId?: number) {
  const invoiceService = useInvoiceService();
  const pageroEInvoice = useSelector((state: AppState) => state.auth.selectedCompany.pageroEInvoice);
  const searchReferencePersons = async (value: string) => {
    return customerId !== undefined && value
      ? invoiceService.searchReferencePersons(customerId, value).then((res) => {
          const options = res.map(
            (item): AutocompleteListItem => ({
              id: item.id ?? 0,
              value: item.name ?? "",
              data: item,
              icon: IconDefinitionConstants.WUser,
              group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
            })
          );

          return options;
        })
      : [];
  };

  const searchReferencePersonsWithCustomer = async (
    customerId: number | undefined,
    value: string
  ): Promise<AutocompleteListItem[]> => {
    return customerId !== undefined && value
      ? invoiceService.searchReferencePersons(customerId, value).then((res) => {
          const options = res.map(
            (item): AutocompleteListItem => ({
              id: item.id ?? 0,
              value: item.name ?? "",
              description: pageroEInvoice ? item.referenceIdentifier : undefined,
              data: item,
              icon: IconDefinitionConstants.WUser,
              group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
            })
          );

          return options;
        })
      : [];
  };

  return { searchReferencePersons, searchReferencePersonsWithCustomer };
}

export default useReferencePersonSearch;
